#import "../../list/AccessGroupsFields.graphql"

mutation AccessGroupUpdate($input: AccessGroupUpdateInput!) {
  accessGroupUpdate(input: $input) {
    accessGroup {
      ...AccessGroupsFields
    }
  }
}
